import React from 'react';
import PropTypes from 'prop-types';
import countryFlagMap from './flagsMapping';

const BASE_URL = 'https://fiverr-dev-res.cloudinary.com/general_assets/flags';

const CountryFlag = ({ code }) => {
    const countryFile = countryFlagMap[code.toLowerCase()];

    return countryFile ? (
        <img className="custom-size country-flag" src={`${BASE_URL}/${countryFile}`} alt={code} loading="lazy" />
    ) : null;
};

CountryFlag.propTypes = {
    code: PropTypes.string,
};

CountryFlag.defaultProps = {
    code: '',
};

export default CountryFlag;
